;(function () {
  angular.module('contrast.errors').factory('ErrorService', ErrorService)

  function ErrorService($log, logger, GoogleAnalyticsService) {
    'ngInject'

    return {
      processError: processError,
      bindFieldErrors: bindFieldErrors,
      getMessage: getMessage,
      processErrorGA: processErrorGA
    }

    /**
     * @param response
     * @param {{}} [options]
     * @param {boolean} [options.suppressToast]
     */
    function processError(response, options) {
      $log.error(response)
      if (!angular.isObject(options)) {
        options = {
          suppressToast: false
        }
      }
      //401, 403, 301 && 503 errors are handled by securityInterceptor(app.js)
      if (_.indexOf([401, 403, 301, 503, 303, 307], response.status) === -1) {
        var data = response.data || response
        if (
          !options.suppressToast &&
          data.messages &&
          data.messages.length > 0
        ) {
          logger.logError(data.messages[0], options)
        }
      }

      if (_isValidStatusForGA(response.status)) {
        GoogleAnalyticsService.sendException(
          _errorMessageGA(response),
          _isFatalGA(response.status)
        )
      }
    }

    /**
     * Whether the HTTP status code is valid for send a Google Analytic event
     * @param status HTTP status code
     */
    function _isValidStatusForGA(status) {
      return !_.includes([401], status)
    }

    /**
     * Sends exception message to Google Analytics
     * @param exceptionMessage A description of the exception
     */
    function processErrorGA(exceptionMessage) {
      GoogleAnalyticsService.sendException(exceptionMessage, false)
    }

    /**
     * Returns a string with format:
     * error message + method + url + HTTP status code
     */
    function _errorMessageGA(response) {
      var message = ''
      var data = response.data || response
      if (data.messages && data.messages.length > 0) {
        message = data.messages[0]
      }

      var method,
        url = ''
      if (angular.isDefined(response.config)) {
        method = response.config.method
        url = response.config.url
      }

      return (
        message +
        ' method:' +
        method +
        ' url:' +
        url +
        ' status:' +
        response.status
      )
    }

    /**
     * Whether the HTTP status code redirects to an error page
     * @param status HTTP status code
     */
    function _isFatalGA(status) {
      return _.includes([401, 403, 301, 503, 303, 307], status)
    }

    function bindFieldErrors(errors, form, errorsMessages) {
      angular.forEach(errors, function (error) {
        form[error.field].$setValidity('server', false)
        form[error.field].$pristine = false
        errorsMessages[error.field] = error.message
      })
    }

    function getMessage(response) {
      var data = response.data || response
      if (data.messages && data.messages.length > 0) {
        return data.messages[0]
      }
      return null
    }
  }
})()
